import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { RxComponent } from 'app/core/components/common/rx.component';

import { CreditService } from '../credit.service';
import { ConfigService } from 'app/core/services/config.service';
import { ProfileService } from 'app/core/components/profile/profile.service';

import { Router, ActivatedRoute } from '@angular/router';
import { NotificationService } from 'app/core/services/notification.service';

declare var $: any;

@Component({
	selector: 'itpx-credit-form',
	templateUrl: './credit-form.component.html',
	styleUrls: ['./credit-form.component.css']
})
export class CreditFormComponent extends RxComponent implements OnInit, AfterViewInit {

	private accountDetails: any;
	private currencyPurchase: string;
	private currencyRevenue: string;
	private bucket: any;
	private component: string = 'credit-application';
	private userDetails: any;

	private optionsPaymentTerm: any;
	private optionsCurrency = [
		{ key: 'EUR', value: 'EUR' },
		{ key: 'USD', value: 'USD' },
		{ key: 'INR', value: 'INR' },
        { key: 'GBP', value: 'GBP' },
		{ key: 'DKK', value: 'DKK' }
	]

	private extraFiles = [];
	private dunningEmails: { key: string, value: string }[] = [];
	private displayNewDunningEmail: boolean = false;
	@ViewChild('ratingWrapper') ratingWrapper: any;
	@ViewChild('uploadWrapper') uploadWrapper: any;
	@ViewChild('auditorWrapper') auditorWrapper: any;
	@ViewChild('hideBtn') hideBtn: any;
	form: FormGroup

	constructor(
		private fb: FormBuilder,
		private service: CreditService,
		private configService: ConfigService,
		private profileService: ProfileService,
		private router: Router,
		private notificationService: NotificationService
	) {
		super()
	}

	ngOnInit() {

		this.bucket = this.configService.get('aws').buyerUploadCreditBucket;

		this.service.getPaymentTermDto()
			.bindToLifecycle(this)
			.subscribe(
				body => {
					let result = [];
					let data = body.data;
					data.forEach(el => {
						if (el.hasOwnProperty('key') && el['value'].indexOf('Days') != -1) {
							result.push(el)
						}
					});
					this.optionsPaymentTerm = result;
				}
			)



		this.form = this.fb.group({
			currentCreditLimitAmount: [{ value: '', disabled: true }],
			currentedCreditLimitCurrency: [''],
			requestedCreditLimitAmount: ['', Validators.required],
			requestedCreditLimitCurrency: [{ value: '', disabled: true }],
			paymentTerm: ['', Validators.required],
			products: ['', Validators.required],
			estimatedPurchase: ['', Validators.required],
			rating: ['', Validators.required],
			ratingAgency: [''],
			ratingFile: [{ value: null, disabled: true }],
			ratingFileName: [{ value: null, disabled: true }],
			annualRevenue: [''],
			balanceSheet: [{ value: '', disabled: true }, Validators.required],
			balanceFileName: [{ value: '', disabled: true }, Validators.required],
			accountAudited: ['', Validators.required],
			auditorWebsite: [''],
			contactPerson: ['', Validators.required],
			additionalInfo: ['', Validators.required],
			dunningEmail: ['', Validators.required]
		})

		this.profileService.getProfile()
			.subscribe(
				body => this.userDetails = body['data']
			);

		this.service.getDetails()
			.bindToLifecycle(this)
			.subscribe(
				body => {
					this.accountDetails = body['data'];
					let currency = this.accountDetails.currency.configKey;
					this.currencyRevenue = this.currencyPurchase = currency;
					this.form.patchValue({
						currentCreditLimitAmount: this.accountDetails.creditLimitAmount,
						currentedCreditLimitCurrency: currency,
						requestedCreditLimitCurrency: currency,
						dunningEmail: this.accountDetails.dunningEmail
					})
					this.BindCreditEmails(this.accountDetails.accountId);
				});

		this.form.controls.rating.valueChanges
			.startWith(false)
			.bindToLifecycle(this)
			.subscribe(toggled => {
				if (toggled) {
					$(this.ratingWrapper.nativeElement).slideDown(200, 'linear');
					$(this.uploadWrapper.nativeElement).slideDown(200, 'linear');
				} else {
					$(this.ratingWrapper.nativeElement).slideUp(200, 'linear');
					$(this.uploadWrapper.nativeElement).slideUp(200, 'linear');
				}
			});

		this.form.controls.accountAudited.valueChanges
			.startWith(false)
			.bindToLifecycle(this)
			.subscribe(toggled => {
				if (toggled) {
					$(this.auditorWrapper.nativeElement).slideDown(200, 'linear');
				} else {
					$(this.auditorWrapper.nativeElement).slideUp(200, 'linear');
				}
			});

		this.form.controls.requestedCreditLimitCurrency.valueChanges
			.startWith(this.currencyPurchase)
			.bindToLifecycle(this)
			.subscribe(change => {
				if (change) {
					this.currencyPurchase = change;
				}
			})
	}

	ngAfterViewInit() {
		this.hideBtn.nativeElement.focus();
	}

	private BindCreditEmails(buyerId: string) {
		this.service.getCreditBuyerEmails(buyerId)
			.bindToLifecycle(this)
			.subscribe(
				body => {
					this.dunningEmails.push({ key: '', value: 'New Email Address' });
					let emailList = body.data;
					for (let i = 0; i < emailList.length; i++) {
						let email = emailList[i];
						this.dunningEmails.push({ key: email, value: email });
					}
				});
	}

	private onDunningEmailChange(e: any) {
		if(e === ''){
			this.displayNewDunningEmail = true;
		} else {
			this.displayNewDunningEmail = false;
		}
	}

	private onSubmit(event: any) {
		let details = this.form.getRawValue();
		delete details['ratingFileName'];
		delete details['balanceFileName'];

		details['paymentTerm'] = { id: details['paymentTerm'] };
		details['supportingFiles'] = [];

		this.extraFiles.forEach(el => {
			details['supportingFiles'].push(el['path'])
		})

		details['buyerName'] = this.accountDetails.name;
		details['buyerId'] = this.accountDetails.accountId;
		details['userName'] = this.userDetails.name;
		details['userEmail'] = this.userDetails.username;

		this.service.addCreditApplication(details)
			.bindToLifecycle(this)
			.subscribe(
				body => {
					this.sendEmail(body.data);
				},
				error => { }
			)

	}

	private sendEmail(data: any) {
		let emailDetails = {
			emailTemplate: 'credit-application-on-create',
			extra: {
				link: this.configService.get('server').sahara + '/agora/account-data/credit/' + data.id + '/details'
			}
		}

		this.service.sendEmail(emailDetails)
			.bindToLifecycle(this)
			.subscribe(
				data => {
					this.router.navigate(['/organization/credit/notification']);
					this.notificationService.success(
						'Successfully submitted Credit Application',
						'Success'
					);
				},
				error => { }
			)

	}

	private onSaveRating(event: any) {
		this.form.patchValue({
			ratingFile: event.data.path,
			ratingFileName: event.data.fileName
		})
	}
	private onSaveBalance(event: any) {
		this.form.patchValue({
			balanceSheet: event.data.path,
			balanceFileName: event.data.fileName
		})
	}
	private onSaveExtra(event: any) {
		this.extraFiles.push({ path: event.data.path, fileName: event.data.fileName })
	}
	private removeExtraFile(file: any) {
		this.extraFiles.forEach(el => {
			if (el['name'] === file.name) {
				let i = this.extraFiles.indexOf(el)
				this.extraFiles.splice(i, 1);
			}
		})
		return this.extraFiles;
	}

}



// WEBPACK FOOTER //
// ./src/app/organization/components/credit/credit-form/credit-form.component.ts